// Generated from FHIRPath.g4 by ANTLR 4.9.3
// jshint ignore: start
const antlr4 = require('../antlr4-index');



const serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786",
    "\u5964\u0002C\u0217\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003",
    "\u0004\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007",
    "\t\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004",
    "\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010",
    "\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013",
    "\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017",
    "\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a",
    "\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e",
    "\t\u001e\u0004\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#",
    "\t#\u0004$\t$\u0004%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004",
    "*\t*\u0004+\t+\u0004,\t,\u0004-\t-\u0004.\t.\u0004/\t/\u00040\t0\u0004",
    "1\t1\u00042\t2\u00043\t3\u00044\t4\u00045\t5\u00046\t6\u00047\t7\u0004",
    "8\t8\u00049\t9\u0004:\t:\u0004;\t;\u0004<\t<\u0004=\t=\u0004>\t>\u0004",
    "?\t?\u0004@\t@\u0004A\tA\u0004B\tB\u0004C\tC\u0004D\tD\u0004E\tE\u0004",
    "F\tF\u0004G\tG\u0004H\tH\u0003\u0002\u0003\u0002\u0003\u0003\u0003\u0003",
    "\u0003\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0006\u0003\u0006",
    "\u0003\u0007\u0003\u0007\u0003\b\u0003\b\u0003\t\u0003\t\u0003\t\u0003",
    "\t\u0003\n\u0003\n\u0003\n\u0003\n\u0003\u000b\u0003\u000b\u0003\f\u0003",
    "\f\u0003\f\u0003\r\u0003\r\u0003\r\u0003\u000e\u0003\u000e\u0003\u000f",
    "\u0003\u000f\u0003\u000f\u0003\u0010\u0003\u0010\u0003\u0011\u0003\u0011",
    "\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0013\u0003\u0013\u0003\u0014",
    "\u0003\u0014\u0003\u0015\u0003\u0015\u0003\u0015\u0003\u0016\u0003\u0016",
    "\u0003\u0016\u0003\u0017\u0003\u0017\u0003\u0017\u0003\u0018\u0003\u0018",
    "\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018",
    "\u0003\u0018\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u001a",
    "\u0003\u001a\u0003\u001a\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b",
    "\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c",
    "\u0003\u001c\u0003\u001c\u0003\u001d\u0003\u001d\u0003\u001e\u0003\u001e",
    "\u0003\u001f\u0003\u001f\u0003 \u0003 \u0003!\u0003!\u0003!\u0003!\u0003",
    "!\u0003\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003#\u0003#\u0003",
    "$\u0003$\u0003$\u0003$\u0003$\u0003$\u0003%\u0003%\u0003%\u0003%\u0003",
    "%\u0003%\u0003%\u0003&\u0003&\u0003&\u0003&\u0003&\u0003&\u0003&\u0003",
    "\'\u0003\'\u0003(\u0003(\u0003(\u0003(\u0003(\u0003)\u0003)\u0003)\u0003",
    ")\u0003)\u0003)\u0003*\u0003*\u0003*\u0003*\u0003*\u0003+\u0003+\u0003",
    "+\u0003+\u0003,\u0003,\u0003,\u0003,\u0003,\u0003-\u0003-\u0003-\u0003",
    "-\u0003-\u0003-\u0003-\u0003.\u0003.\u0003.\u0003.\u0003.\u0003.\u0003",
    ".\u0003/\u0003/\u0003/\u0003/\u0003/\u0003/\u0003/\u0003/\u0003/\u0003",
    "/\u0003/\u0003/\u00030\u00030\u00030\u00030\u00030\u00030\u00031\u0003",
    "1\u00031\u00031\u00031\u00031\u00031\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00033\u00033\u00033\u00033\u00033\u00034\u00034\u00034\u0003",
    "4\u00034\u00034\u00035\u00035\u00035\u00035\u00035\u00035\u00035\u0003",
    "5\u00036\u00036\u00036\u00036\u00036\u00036\u00036\u00036\u00037\u0003",
    "7\u00037\u00037\u00037\u00037\u00037\u00037\u00037\u00037\u00037\u0003",
    "7\u00037\u00038\u00038\u00038\u00039\u00039\u00039\u00039\u00039\u0005",
    "9\u0186\n9\u00059\u0188\n9\u0003:\u0003:\u0003:\u0003:\u0003;\u0003",
    ";\u0003;\u0003;\u0003;\u0003;\u0003;\u0003;\u0003;\u0003;\u0005;\u0198",
    "\n;\u0005;\u019a\n;\u0003<\u0003<\u0003<\u0003<\u0003<\u0003<\u0003",
    "<\u0003<\u0003<\u0003<\u0006<\u01a6\n<\r<\u000e<\u01a7\u0005<\u01aa",
    "\n<\u0005<\u01ac\n<\u0005<\u01ae\n<\u0003=\u0003=\u0003=\u0003=\u0003",
    "=\u0003=\u0003=\u0005=\u01b7\n=\u0003>\u0005>\u01ba\n>\u0003>\u0007",
    ">\u01bd\n>\f>\u000e>\u01c0\u000b>\u0003?\u0003?\u0003?\u0007?\u01c5",
    "\n?\f?\u000e?\u01c8\u000b?\u0003?\u0003?\u0003@\u0003@\u0003@\u0007",
    "@\u01cf\n@\f@\u000e@\u01d2\u000b@\u0003@\u0003@\u0003A\u0006A\u01d7",
    "\nA\rA\u000eA\u01d8\u0003A\u0003A\u0006A\u01dd\nA\rA\u000eA\u01de\u0005",
    "A\u01e1\nA\u0003B\u0006B\u01e4\nB\rB\u000eB\u01e5\u0003B\u0005B\u01e9",
    "\nB\u0003C\u0006C\u01ec\nC\rC\u000eC\u01ed\u0003C\u0003C\u0003D\u0003",
    "D\u0003D\u0003D\u0007D\u01f6\nD\fD\u000eD\u01f9\u000bD\u0003D\u0003",
    "D\u0003D\u0003D\u0003D\u0003E\u0003E\u0003E\u0003E\u0007E\u0204\nE\f",
    "E\u000eE\u0207\u000bE\u0003E\u0003E\u0003F\u0003F\u0003F\u0005F\u020e",
    "\nF\u0003G\u0003G\u0003G\u0003G\u0003G\u0003G\u0003H\u0003H\u0005\u01c6",
    "\u01d0\u01f7\u0002I\u0003\u0003\u0005\u0004\u0007\u0005\t\u0006\u000b",
    "\u0007\r\b\u000f\t\u0011\n\u0013\u000b\u0015\f\u0017\r\u0019\u000e\u001b",
    "\u000f\u001d\u0010\u001f\u0011!\u0012#\u0013%\u0014\'\u0015)\u0016+",
    "\u0017-\u0018/\u00191\u001a3\u001b5\u001c7\u001d9\u001e;\u001f= ?!A",
    "\"C#E$G%I&K\'M(O)Q*S+U,W-Y.[/]0_1a2c3e4g5i6k7m8o9q:s;u\u0002w\u0002",
    "y\u0002{<}=\u007f>\u0081?\u0083@\u0085A\u0087B\u0089C\u008b\u0002\u008d",
    "\u0002\u008f\u0002\u0003\u0002\n\u0003\u00022;\u0004\u0002--//\u0005",
    "\u0002C\\aac|\u0006\u00022;C\\aac|\u0005\u0002\u000b\f\u000f\u000f\"",
    "\"\u0004\u0002\f\f\u000f\u000f\n\u0002))11^^bbhhppttvv\u0005\u00022",
    ";CHch\u0002\u0227\u0002\u0003\u0003\u0002\u0002\u0002\u0002\u0005\u0003",
    "\u0002\u0002\u0002\u0002\u0007\u0003\u0002\u0002\u0002\u0002\t\u0003",
    "\u0002\u0002\u0002\u0002\u000b\u0003\u0002\u0002\u0002\u0002\r\u0003",
    "\u0002\u0002\u0002\u0002\u000f\u0003\u0002\u0002\u0002\u0002\u0011\u0003",
    "\u0002\u0002\u0002\u0002\u0013\u0003\u0002\u0002\u0002\u0002\u0015\u0003",
    "\u0002\u0002\u0002\u0002\u0017\u0003\u0002\u0002\u0002\u0002\u0019\u0003",
    "\u0002\u0002\u0002\u0002\u001b\u0003\u0002\u0002\u0002\u0002\u001d\u0003",
    "\u0002\u0002\u0002\u0002\u001f\u0003\u0002\u0002\u0002\u0002!\u0003",
    "\u0002\u0002\u0002\u0002#\u0003\u0002\u0002\u0002\u0002%\u0003\u0002",
    "\u0002\u0002\u0002\'\u0003\u0002\u0002\u0002\u0002)\u0003\u0002\u0002",
    "\u0002\u0002+\u0003\u0002\u0002\u0002\u0002-\u0003\u0002\u0002\u0002",
    "\u0002/\u0003\u0002\u0002\u0002\u00021\u0003\u0002\u0002\u0002\u0002",
    "3\u0003\u0002\u0002\u0002\u00025\u0003\u0002\u0002\u0002\u00027\u0003",
    "\u0002\u0002\u0002\u00029\u0003\u0002\u0002\u0002\u0002;\u0003\u0002",
    "\u0002\u0002\u0002=\u0003\u0002\u0002\u0002\u0002?\u0003\u0002\u0002",
    "\u0002\u0002A\u0003\u0002\u0002\u0002\u0002C\u0003\u0002\u0002\u0002",
    "\u0002E\u0003\u0002\u0002\u0002\u0002G\u0003\u0002\u0002\u0002\u0002",
    "I\u0003\u0002\u0002\u0002\u0002K\u0003\u0002\u0002\u0002\u0002M\u0003",
    "\u0002\u0002\u0002\u0002O\u0003\u0002\u0002\u0002\u0002Q\u0003\u0002",
    "\u0002\u0002\u0002S\u0003\u0002\u0002\u0002\u0002U\u0003\u0002\u0002",
    "\u0002\u0002W\u0003\u0002\u0002\u0002\u0002Y\u0003\u0002\u0002\u0002",
    "\u0002[\u0003\u0002\u0002\u0002\u0002]\u0003\u0002\u0002\u0002\u0002",
    "_\u0003\u0002\u0002\u0002\u0002a\u0003\u0002\u0002\u0002\u0002c\u0003",
    "\u0002\u0002\u0002\u0002e\u0003\u0002\u0002\u0002\u0002g\u0003\u0002",
    "\u0002\u0002\u0002i\u0003\u0002\u0002\u0002\u0002k\u0003\u0002\u0002",
    "\u0002\u0002m\u0003\u0002\u0002\u0002\u0002o\u0003\u0002\u0002\u0002",
    "\u0002q\u0003\u0002\u0002\u0002\u0002s\u0003\u0002\u0002\u0002\u0002",
    "{\u0003\u0002\u0002\u0002\u0002}\u0003\u0002\u0002\u0002\u0002\u007f",
    "\u0003\u0002\u0002\u0002\u0002\u0081\u0003\u0002\u0002\u0002\u0002\u0083",
    "\u0003\u0002\u0002\u0002\u0002\u0085\u0003\u0002\u0002\u0002\u0002\u0087",
    "\u0003\u0002\u0002\u0002\u0002\u0089\u0003\u0002\u0002\u0002\u0003\u0091",
    "\u0003\u0002\u0002\u0002\u0005\u0093\u0003\u0002\u0002\u0002\u0007\u0095",
    "\u0003\u0002\u0002\u0002\t\u0097\u0003\u0002\u0002\u0002\u000b\u0099",
    "\u0003\u0002\u0002\u0002\r\u009b\u0003\u0002\u0002\u0002\u000f\u009d",
    "\u0003\u0002\u0002\u0002\u0011\u009f\u0003\u0002\u0002\u0002\u0013\u00a3",
    "\u0003\u0002\u0002\u0002\u0015\u00a7\u0003\u0002\u0002\u0002\u0017\u00a9",
    "\u0003\u0002\u0002\u0002\u0019\u00ac\u0003\u0002\u0002\u0002\u001b\u00af",
    "\u0003\u0002\u0002\u0002\u001d\u00b1\u0003\u0002\u0002\u0002\u001f\u00b4",
    "\u0003\u0002\u0002\u0002!\u00b6\u0003\u0002\u0002\u0002#\u00b8\u0003",
    "\u0002\u0002\u0002%\u00bb\u0003\u0002\u0002\u0002\'\u00bd\u0003\u0002",
    "\u0002\u0002)\u00bf\u0003\u0002\u0002\u0002+\u00c2\u0003\u0002\u0002",
    "\u0002-\u00c5\u0003\u0002\u0002\u0002/\u00c8\u0003\u0002\u0002\u0002",
    "1\u00d1\u0003\u0002\u0002\u00023\u00d5\u0003\u0002\u0002\u00025\u00d8",
    "\u0003\u0002\u0002\u00027\u00dc\u0003\u0002\u0002\u00029\u00e4\u0003",
    "\u0002\u0002\u0002;\u00e6\u0003\u0002\u0002\u0002=\u00e8\u0003\u0002",
    "\u0002\u0002?\u00ea\u0003\u0002\u0002\u0002A\u00ec\u0003\u0002\u0002",
    "\u0002C\u00f1\u0003\u0002\u0002\u0002E\u00f7\u0003\u0002\u0002\u0002",
    "G\u00f9\u0003\u0002\u0002\u0002I\u00ff\u0003\u0002\u0002\u0002K\u0106",
    "\u0003\u0002\u0002\u0002M\u010d\u0003\u0002\u0002\u0002O\u010f\u0003",
    "\u0002\u0002\u0002Q\u0114\u0003\u0002\u0002\u0002S\u011a\u0003\u0002",
    "\u0002\u0002U\u011f\u0003\u0002\u0002\u0002W\u0123\u0003\u0002\u0002",
    "\u0002Y\u0128\u0003\u0002\u0002\u0002[\u012f\u0003\u0002\u0002\u0002",
    "]\u0136\u0003\u0002\u0002\u0002_\u0142\u0003\u0002\u0002\u0002a\u0148",
    "\u0003\u0002\u0002\u0002c\u014f\u0003\u0002\u0002\u0002e\u0155\u0003",
    "\u0002\u0002\u0002g\u015a\u0003\u0002\u0002\u0002i\u0160\u0003\u0002",
    "\u0002\u0002k\u0168\u0003\u0002\u0002\u0002m\u0170\u0003\u0002\u0002",
    "\u0002o\u017d\u0003\u0002\u0002\u0002q\u0180\u0003\u0002\u0002\u0002",
    "s\u0189\u0003\u0002\u0002\u0002u\u018d\u0003\u0002\u0002\u0002w\u019b",
    "\u0003\u0002\u0002\u0002y\u01b6\u0003\u0002\u0002\u0002{\u01b9\u0003",
    "\u0002\u0002\u0002}\u01c1\u0003\u0002\u0002\u0002\u007f\u01cb\u0003",
    "\u0002\u0002\u0002\u0081\u01d6\u0003\u0002\u0002\u0002\u0083\u01e3\u0003",
    "\u0002\u0002\u0002\u0085\u01eb\u0003\u0002\u0002\u0002\u0087\u01f1\u0003",
    "\u0002\u0002\u0002\u0089\u01ff\u0003\u0002\u0002\u0002\u008b\u020a\u0003",
    "\u0002\u0002\u0002\u008d\u020f\u0003\u0002\u0002\u0002\u008f\u0215\u0003",
    "\u0002\u0002\u0002\u0091\u0092\u00070\u0002\u0002\u0092\u0004\u0003",
    "\u0002\u0002\u0002\u0093\u0094\u0007]\u0002\u0002\u0094\u0006\u0003",
    "\u0002\u0002\u0002\u0095\u0096\u0007_\u0002\u0002\u0096\b\u0003\u0002",
    "\u0002\u0002\u0097\u0098\u0007-\u0002\u0002\u0098\n\u0003\u0002\u0002",
    "\u0002\u0099\u009a\u0007/\u0002\u0002\u009a\f\u0003\u0002\u0002\u0002",
    "\u009b\u009c\u0007,\u0002\u0002\u009c\u000e\u0003\u0002\u0002\u0002",
    "\u009d\u009e\u00071\u0002\u0002\u009e\u0010\u0003\u0002\u0002\u0002",
    "\u009f\u00a0\u0007f\u0002\u0002\u00a0\u00a1\u0007k\u0002\u0002\u00a1",
    "\u00a2\u0007x\u0002\u0002\u00a2\u0012\u0003\u0002\u0002\u0002\u00a3",
    "\u00a4\u0007o\u0002\u0002\u00a4\u00a5\u0007q\u0002\u0002\u00a5\u00a6",
    "\u0007f\u0002\u0002\u00a6\u0014\u0003\u0002\u0002\u0002\u00a7\u00a8",
    "\u0007(\u0002\u0002\u00a8\u0016\u0003\u0002\u0002\u0002\u00a9\u00aa",
    "\u0007k\u0002\u0002\u00aa\u00ab\u0007u\u0002\u0002\u00ab\u0018\u0003",
    "\u0002\u0002\u0002\u00ac\u00ad\u0007c\u0002\u0002\u00ad\u00ae\u0007",
    "u\u0002\u0002\u00ae\u001a\u0003\u0002\u0002\u0002\u00af\u00b0\u0007",
    "~\u0002\u0002\u00b0\u001c\u0003\u0002\u0002\u0002\u00b1\u00b2\u0007",
    ">\u0002\u0002\u00b2\u00b3\u0007?\u0002\u0002\u00b3\u001e\u0003\u0002",
    "\u0002\u0002\u00b4\u00b5\u0007>\u0002\u0002\u00b5 \u0003\u0002\u0002",
    "\u0002\u00b6\u00b7\u0007@\u0002\u0002\u00b7\"\u0003\u0002\u0002\u0002",
    "\u00b8\u00b9\u0007@\u0002\u0002\u00b9\u00ba\u0007?\u0002\u0002\u00ba",
    "$\u0003\u0002\u0002\u0002\u00bb\u00bc\u0007?\u0002\u0002\u00bc&\u0003",
    "\u0002\u0002\u0002\u00bd\u00be\u0007\u0080\u0002\u0002\u00be(\u0003",
    "\u0002\u0002\u0002\u00bf\u00c0\u0007#\u0002\u0002\u00c0\u00c1\u0007",
    "?\u0002\u0002\u00c1*\u0003\u0002\u0002\u0002\u00c2\u00c3\u0007#\u0002",
    "\u0002\u00c3\u00c4\u0007\u0080\u0002\u0002\u00c4,\u0003\u0002\u0002",
    "\u0002\u00c5\u00c6\u0007k\u0002\u0002\u00c6\u00c7\u0007p\u0002\u0002",
    "\u00c7.\u0003\u0002\u0002\u0002\u00c8\u00c9\u0007e\u0002\u0002\u00c9",
    "\u00ca\u0007q\u0002\u0002\u00ca\u00cb\u0007p\u0002\u0002\u00cb\u00cc",
    "\u0007v\u0002\u0002\u00cc\u00cd\u0007c\u0002\u0002\u00cd\u00ce\u0007",
    "k\u0002\u0002\u00ce\u00cf\u0007p\u0002\u0002\u00cf\u00d0\u0007u\u0002",
    "\u0002\u00d00\u0003\u0002\u0002\u0002\u00d1\u00d2\u0007c\u0002\u0002",
    "\u00d2\u00d3\u0007p\u0002\u0002\u00d3\u00d4\u0007f\u0002\u0002\u00d4",
    "2\u0003\u0002\u0002\u0002\u00d5\u00d6\u0007q\u0002\u0002\u00d6\u00d7",
    "\u0007t\u0002\u0002\u00d74\u0003\u0002\u0002\u0002\u00d8\u00d9\u0007",
    "z\u0002\u0002\u00d9\u00da\u0007q\u0002\u0002\u00da\u00db\u0007t\u0002",
    "\u0002\u00db6\u0003\u0002\u0002\u0002\u00dc\u00dd\u0007k\u0002\u0002",
    "\u00dd\u00de\u0007o\u0002\u0002\u00de\u00df\u0007r\u0002\u0002\u00df",
    "\u00e0\u0007n\u0002\u0002\u00e0\u00e1\u0007k\u0002\u0002\u00e1\u00e2",
    "\u0007g\u0002\u0002\u00e2\u00e3\u0007u\u0002\u0002\u00e38\u0003\u0002",
    "\u0002\u0002\u00e4\u00e5\u0007*\u0002\u0002\u00e5:\u0003\u0002\u0002",
    "\u0002\u00e6\u00e7\u0007+\u0002\u0002\u00e7<\u0003\u0002\u0002\u0002",
    "\u00e8\u00e9\u0007}\u0002\u0002\u00e9>\u0003\u0002\u0002\u0002\u00ea",
    "\u00eb\u0007\u007f\u0002\u0002\u00eb@\u0003\u0002\u0002\u0002\u00ec",
    "\u00ed\u0007v\u0002\u0002\u00ed\u00ee\u0007t\u0002\u0002\u00ee\u00ef",
    "\u0007w\u0002\u0002\u00ef\u00f0\u0007g\u0002\u0002\u00f0B\u0003\u0002",
    "\u0002\u0002\u00f1\u00f2\u0007h\u0002\u0002\u00f2\u00f3\u0007c\u0002",
    "\u0002\u00f3\u00f4\u0007n\u0002\u0002\u00f4\u00f5\u0007u\u0002\u0002",
    "\u00f5\u00f6\u0007g\u0002\u0002\u00f6D\u0003\u0002\u0002\u0002\u00f7",
    "\u00f8\u0007\'\u0002\u0002\u00f8F\u0003\u0002\u0002\u0002\u00f9\u00fa",
    "\u0007&\u0002\u0002\u00fa\u00fb\u0007v\u0002\u0002\u00fb\u00fc\u0007",
    "j\u0002\u0002\u00fc\u00fd\u0007k\u0002\u0002\u00fd\u00fe\u0007u\u0002",
    "\u0002\u00feH\u0003\u0002\u0002\u0002\u00ff\u0100\u0007&\u0002\u0002",
    "\u0100\u0101\u0007k\u0002\u0002\u0101\u0102\u0007p\u0002\u0002\u0102",
    "\u0103\u0007f\u0002\u0002\u0103\u0104\u0007g\u0002\u0002\u0104\u0105",
    "\u0007z\u0002\u0002\u0105J\u0003\u0002\u0002\u0002\u0106\u0107\u0007",
    "&\u0002\u0002\u0107\u0108\u0007v\u0002\u0002\u0108\u0109\u0007q\u0002",
    "\u0002\u0109\u010a\u0007v\u0002\u0002\u010a\u010b\u0007c\u0002\u0002",
    "\u010b\u010c\u0007n\u0002\u0002\u010cL\u0003\u0002\u0002\u0002\u010d",
    "\u010e\u0007.\u0002\u0002\u010eN\u0003\u0002\u0002\u0002\u010f\u0110",
    "\u0007{\u0002\u0002\u0110\u0111\u0007g\u0002\u0002\u0111\u0112\u0007",
    "c\u0002\u0002\u0112\u0113\u0007t\u0002\u0002\u0113P\u0003\u0002\u0002",
    "\u0002\u0114\u0115\u0007o\u0002\u0002\u0115\u0116\u0007q\u0002\u0002",
    "\u0116\u0117\u0007p\u0002\u0002\u0117\u0118\u0007v\u0002\u0002\u0118",
    "\u0119\u0007j\u0002\u0002\u0119R\u0003\u0002\u0002\u0002\u011a\u011b",
    "\u0007y\u0002\u0002\u011b\u011c\u0007g\u0002\u0002\u011c\u011d\u0007",
    "g\u0002\u0002\u011d\u011e\u0007m\u0002\u0002\u011eT\u0003\u0002\u0002",
    "\u0002\u011f\u0120\u0007f\u0002\u0002\u0120\u0121\u0007c\u0002\u0002",
    "\u0121\u0122\u0007{\u0002\u0002\u0122V\u0003\u0002\u0002\u0002\u0123",
    "\u0124\u0007j\u0002\u0002\u0124\u0125\u0007q\u0002\u0002\u0125\u0126",
    "\u0007w\u0002\u0002\u0126\u0127\u0007t\u0002\u0002\u0127X\u0003\u0002",
    "\u0002\u0002\u0128\u0129\u0007o\u0002\u0002\u0129\u012a\u0007k\u0002",
    "\u0002\u012a\u012b\u0007p\u0002\u0002\u012b\u012c\u0007w\u0002\u0002",
    "\u012c\u012d\u0007v\u0002\u0002\u012d\u012e\u0007g\u0002\u0002\u012e",
    "Z\u0003\u0002\u0002\u0002\u012f\u0130\u0007u\u0002\u0002\u0130\u0131",
    "\u0007g\u0002\u0002\u0131\u0132\u0007e\u0002\u0002\u0132\u0133\u0007",
    "q\u0002\u0002\u0133\u0134\u0007p\u0002\u0002\u0134\u0135\u0007f\u0002",
    "\u0002\u0135\\\u0003\u0002\u0002\u0002\u0136\u0137\u0007o\u0002\u0002",
    "\u0137\u0138\u0007k\u0002\u0002\u0138\u0139\u0007n\u0002\u0002\u0139",
    "\u013a\u0007n\u0002\u0002\u013a\u013b\u0007k\u0002\u0002\u013b\u013c",
    "\u0007u\u0002\u0002\u013c\u013d\u0007g\u0002\u0002\u013d\u013e\u0007",
    "e\u0002\u0002\u013e\u013f\u0007q\u0002\u0002\u013f\u0140\u0007p\u0002",
    "\u0002\u0140\u0141\u0007f\u0002\u0002\u0141^\u0003\u0002\u0002\u0002",
    "\u0142\u0143\u0007{\u0002\u0002\u0143\u0144\u0007g\u0002\u0002\u0144",
    "\u0145\u0007c\u0002\u0002\u0145\u0146\u0007t\u0002\u0002\u0146\u0147",
    "\u0007u\u0002\u0002\u0147`\u0003\u0002\u0002\u0002\u0148\u0149\u0007",
    "o\u0002\u0002\u0149\u014a\u0007q\u0002\u0002\u014a\u014b\u0007p\u0002",
    "\u0002\u014b\u014c\u0007v\u0002\u0002\u014c\u014d\u0007j\u0002\u0002",
    "\u014d\u014e\u0007u\u0002\u0002\u014eb\u0003\u0002\u0002\u0002\u014f",
    "\u0150\u0007y\u0002\u0002\u0150\u0151\u0007g\u0002\u0002\u0151\u0152",
    "\u0007g\u0002\u0002\u0152\u0153\u0007m\u0002\u0002\u0153\u0154\u0007",
    "u\u0002\u0002\u0154d\u0003\u0002\u0002\u0002\u0155\u0156\u0007f\u0002",
    "\u0002\u0156\u0157\u0007c\u0002\u0002\u0157\u0158\u0007{\u0002\u0002",
    "\u0158\u0159\u0007u\u0002\u0002\u0159f\u0003\u0002\u0002\u0002\u015a",
    "\u015b\u0007j\u0002\u0002\u015b\u015c\u0007q\u0002\u0002\u015c\u015d",
    "\u0007w\u0002\u0002\u015d\u015e\u0007t\u0002\u0002\u015e\u015f\u0007",
    "u\u0002\u0002\u015fh\u0003\u0002\u0002\u0002\u0160\u0161\u0007o\u0002",
    "\u0002\u0161\u0162\u0007k\u0002\u0002\u0162\u0163\u0007p\u0002\u0002",
    "\u0163\u0164\u0007w\u0002\u0002\u0164\u0165\u0007v\u0002\u0002\u0165",
    "\u0166\u0007g\u0002\u0002\u0166\u0167\u0007u\u0002\u0002\u0167j\u0003",
    "\u0002\u0002\u0002\u0168\u0169\u0007u\u0002\u0002\u0169\u016a\u0007",
    "g\u0002\u0002\u016a\u016b\u0007e\u0002\u0002\u016b\u016c\u0007q\u0002",
    "\u0002\u016c\u016d\u0007p\u0002\u0002\u016d\u016e\u0007f\u0002\u0002",
    "\u016e\u016f\u0007u\u0002\u0002\u016fl\u0003\u0002\u0002\u0002\u0170",
    "\u0171\u0007o\u0002\u0002\u0171\u0172\u0007k\u0002\u0002\u0172\u0173",
    "\u0007n\u0002\u0002\u0173\u0174\u0007n\u0002\u0002\u0174\u0175\u0007",
    "k\u0002\u0002\u0175\u0176\u0007u\u0002\u0002\u0176\u0177\u0007g\u0002",
    "\u0002\u0177\u0178\u0007e\u0002\u0002\u0178\u0179\u0007q\u0002\u0002",
    "\u0179\u017a\u0007p\u0002\u0002\u017a\u017b\u0007f\u0002\u0002\u017b",
    "\u017c\u0007u\u0002\u0002\u017cn\u0003\u0002\u0002\u0002\u017d\u017e",
    "\u0007B\u0002\u0002\u017e\u017f\u0005u;\u0002\u017fp\u0003\u0002\u0002",
    "\u0002\u0180\u0181\u0007B\u0002\u0002\u0181\u0182\u0005u;\u0002\u0182",
    "\u0187\u0007V\u0002\u0002\u0183\u0185\u0005w<\u0002\u0184\u0186\u0005",
    "y=\u0002\u0185\u0184\u0003\u0002\u0002\u0002\u0185\u0186\u0003\u0002",
    "\u0002\u0002\u0186\u0188\u0003\u0002\u0002\u0002\u0187\u0183\u0003\u0002",
    "\u0002\u0002\u0187\u0188\u0003\u0002\u0002\u0002\u0188r\u0003\u0002",
    "\u0002\u0002\u0189\u018a\u0007B\u0002\u0002\u018a\u018b\u0007V\u0002",
    "\u0002\u018b\u018c\u0005w<\u0002\u018ct\u0003\u0002\u0002\u0002\u018d",
    "\u018e\t\u0002\u0002\u0002\u018e\u018f\t\u0002\u0002\u0002\u018f\u0190",
    "\t\u0002\u0002\u0002\u0190\u0199\t\u0002\u0002\u0002\u0191\u0192\u0007",
    "/\u0002\u0002\u0192\u0193\t\u0002\u0002\u0002\u0193\u0197\t\u0002\u0002",
    "\u0002\u0194\u0195\u0007/\u0002\u0002\u0195\u0196\t\u0002\u0002\u0002",
    "\u0196\u0198\t\u0002\u0002\u0002\u0197\u0194\u0003\u0002\u0002\u0002",
    "\u0197\u0198\u0003\u0002\u0002\u0002\u0198\u019a\u0003\u0002\u0002\u0002",
    "\u0199\u0191\u0003\u0002\u0002\u0002\u0199\u019a\u0003\u0002\u0002\u0002",
    "\u019av\u0003\u0002\u0002\u0002\u019b\u019c\t\u0002\u0002\u0002\u019c",
    "\u01ad\t\u0002\u0002\u0002\u019d\u019e\u0007<\u0002\u0002\u019e\u019f",
    "\t\u0002\u0002\u0002\u019f\u01ab\t\u0002\u0002\u0002\u01a0\u01a1\u0007",
    "<\u0002\u0002\u01a1\u01a2\t\u0002\u0002\u0002\u01a2\u01a9\t\u0002\u0002",
    "\u0002\u01a3\u01a5\u00070\u0002\u0002\u01a4\u01a6\t\u0002\u0002\u0002",
    "\u01a5\u01a4\u0003\u0002\u0002\u0002\u01a6\u01a7\u0003\u0002\u0002\u0002",
    "\u01a7\u01a5\u0003\u0002\u0002\u0002\u01a7\u01a8\u0003\u0002\u0002\u0002",
    "\u01a8\u01aa\u0003\u0002\u0002\u0002\u01a9\u01a3\u0003\u0002\u0002\u0002",
    "\u01a9\u01aa\u0003\u0002\u0002\u0002\u01aa\u01ac\u0003\u0002\u0002\u0002",
    "\u01ab\u01a0\u0003\u0002\u0002\u0002\u01ab\u01ac\u0003\u0002\u0002\u0002",
    "\u01ac\u01ae\u0003\u0002\u0002\u0002\u01ad\u019d\u0003\u0002\u0002\u0002",
    "\u01ad\u01ae\u0003\u0002\u0002\u0002\u01aex\u0003\u0002\u0002\u0002",
    "\u01af\u01b7\u0007\\\u0002\u0002\u01b0\u01b1\t\u0003\u0002\u0002\u01b1",
    "\u01b2\t\u0002\u0002\u0002\u01b2\u01b3\t\u0002\u0002\u0002\u01b3\u01b4",
    "\u0007<\u0002\u0002\u01b4\u01b5\t\u0002\u0002\u0002\u01b5\u01b7\t\u0002",
    "\u0002\u0002\u01b6\u01af\u0003\u0002\u0002\u0002\u01b6\u01b0\u0003\u0002",
    "\u0002\u0002\u01b7z\u0003\u0002\u0002\u0002\u01b8\u01ba\t\u0004\u0002",
    "\u0002\u01b9\u01b8\u0003\u0002\u0002\u0002\u01ba\u01be\u0003\u0002\u0002",
    "\u0002\u01bb\u01bd\t\u0005\u0002\u0002\u01bc\u01bb\u0003\u0002\u0002",
    "\u0002\u01bd\u01c0\u0003\u0002\u0002\u0002\u01be\u01bc\u0003\u0002\u0002",
    "\u0002\u01be\u01bf\u0003\u0002\u0002\u0002\u01bf|\u0003\u0002\u0002",
    "\u0002\u01c0\u01be\u0003\u0002\u0002\u0002\u01c1\u01c6\u0007b\u0002",
    "\u0002\u01c2\u01c5\u0005\u008bF\u0002\u01c3\u01c5\u000b\u0002\u0002",
    "\u0002\u01c4\u01c2\u0003\u0002\u0002\u0002\u01c4\u01c3\u0003\u0002\u0002",
    "\u0002\u01c5\u01c8\u0003\u0002\u0002\u0002\u01c6\u01c7\u0003\u0002\u0002",
    "\u0002\u01c6\u01c4\u0003\u0002\u0002\u0002\u01c7\u01c9\u0003\u0002\u0002",
    "\u0002\u01c8\u01c6\u0003\u0002\u0002\u0002\u01c9\u01ca\u0007b\u0002",
    "\u0002\u01ca~\u0003\u0002\u0002\u0002\u01cb\u01d0\u0007)\u0002\u0002",
    "\u01cc\u01cf\u0005\u008bF\u0002\u01cd\u01cf\u000b\u0002\u0002\u0002",
    "\u01ce\u01cc\u0003\u0002\u0002\u0002\u01ce\u01cd\u0003\u0002\u0002\u0002",
    "\u01cf\u01d2\u0003\u0002\u0002\u0002\u01d0\u01d1\u0003\u0002\u0002\u0002",
    "\u01d0\u01ce\u0003\u0002\u0002\u0002\u01d1\u01d3\u0003\u0002\u0002\u0002",
    "\u01d2\u01d0\u0003\u0002\u0002\u0002\u01d3\u01d4\u0007)\u0002\u0002",
    "\u01d4\u0080\u0003\u0002\u0002\u0002\u01d5\u01d7\t\u0002\u0002\u0002",
    "\u01d6\u01d5\u0003\u0002\u0002\u0002\u01d7\u01d8\u0003\u0002\u0002\u0002",
    "\u01d8\u01d6\u0003\u0002\u0002\u0002\u01d8\u01d9\u0003\u0002\u0002\u0002",
    "\u01d9\u01e0\u0003\u0002\u0002\u0002\u01da\u01dc\u00070\u0002\u0002",
    "\u01db\u01dd\t\u0002\u0002\u0002\u01dc\u01db\u0003\u0002\u0002\u0002",
    "\u01dd\u01de\u0003\u0002\u0002\u0002\u01de\u01dc\u0003\u0002\u0002\u0002",
    "\u01de\u01df\u0003\u0002\u0002\u0002\u01df\u01e1\u0003\u0002\u0002\u0002",
    "\u01e0\u01da\u0003\u0002\u0002\u0002\u01e0\u01e1\u0003\u0002\u0002\u0002",
    "\u01e1\u0082\u0003\u0002\u0002\u0002\u01e2\u01e4\t\u0002\u0002\u0002",
    "\u01e3\u01e2\u0003\u0002\u0002\u0002\u01e4\u01e5\u0003\u0002\u0002\u0002",
    "\u01e5\u01e3\u0003\u0002\u0002\u0002\u01e5\u01e6\u0003\u0002\u0002\u0002",
    "\u01e6\u01e8\u0003\u0002\u0002\u0002\u01e7\u01e9\u0007N\u0002\u0002",
    "\u01e8\u01e7\u0003\u0002\u0002\u0002\u01e8\u01e9\u0003\u0002\u0002\u0002",
    "\u01e9\u0084\u0003\u0002\u0002\u0002\u01ea\u01ec\t\u0006\u0002\u0002",
    "\u01eb\u01ea\u0003\u0002\u0002\u0002\u01ec\u01ed\u0003\u0002\u0002\u0002",
    "\u01ed\u01eb\u0003\u0002\u0002\u0002\u01ed\u01ee\u0003\u0002\u0002\u0002",
    "\u01ee\u01ef\u0003\u0002\u0002\u0002\u01ef\u01f0\bC\u0002\u0002\u01f0",
    "\u0086\u0003\u0002\u0002\u0002\u01f1\u01f2\u00071\u0002\u0002\u01f2",
    "\u01f3\u0007,\u0002\u0002\u01f3\u01f7\u0003\u0002\u0002\u0002\u01f4",
    "\u01f6\u000b\u0002\u0002\u0002\u01f5\u01f4\u0003\u0002\u0002\u0002\u01f6",
    "\u01f9\u0003\u0002\u0002\u0002\u01f7\u01f8\u0003\u0002\u0002\u0002\u01f7",
    "\u01f5\u0003\u0002\u0002\u0002\u01f8\u01fa\u0003\u0002\u0002\u0002\u01f9",
    "\u01f7\u0003\u0002\u0002\u0002\u01fa\u01fb\u0007,\u0002\u0002\u01fb",
    "\u01fc\u00071\u0002\u0002\u01fc\u01fd\u0003\u0002\u0002\u0002\u01fd",
    "\u01fe\bD\u0002\u0002\u01fe\u0088\u0003\u0002\u0002\u0002\u01ff\u0200",
    "\u00071\u0002\u0002\u0200\u0201\u00071\u0002\u0002\u0201\u0205\u0003",
    "\u0002\u0002\u0002\u0202\u0204\n\u0007\u0002\u0002\u0203\u0202\u0003",
    "\u0002\u0002\u0002\u0204\u0207\u0003\u0002\u0002\u0002\u0205\u0203\u0003",
    "\u0002\u0002\u0002\u0205\u0206\u0003\u0002\u0002\u0002\u0206\u0208\u0003",
    "\u0002\u0002\u0002\u0207\u0205\u0003\u0002\u0002\u0002\u0208\u0209\b",
    "E\u0002\u0002\u0209\u008a\u0003\u0002\u0002\u0002\u020a\u020d\u0007",
    "^\u0002\u0002\u020b\u020e\t\b\u0002\u0002\u020c\u020e\u0005\u008dG\u0002",
    "\u020d\u020b\u0003\u0002\u0002\u0002\u020d\u020c\u0003\u0002\u0002\u0002",
    "\u020e\u008c\u0003\u0002\u0002\u0002\u020f\u0210\u0007w\u0002\u0002",
    "\u0210\u0211\u0005\u008fH\u0002\u0211\u0212\u0005\u008fH\u0002\u0212",
    "\u0213\u0005\u008fH\u0002\u0213\u0214\u0005\u008fH\u0002\u0214\u008e",
    "\u0003\u0002\u0002\u0002\u0215\u0216\t\t\u0002\u0002\u0216\u0090\u0003",
    "\u0002\u0002\u0002\u001c\u0002\u0185\u0187\u0197\u0199\u01a7\u01a9\u01ab",
    "\u01ad\u01b6\u01b9\u01bc\u01be\u01c4\u01c6\u01ce\u01d0\u01d8\u01de\u01e0",
    "\u01e5\u01e8\u01ed\u01f7\u0205\u020d\u0003\u0002\u0003\u0002"].join("");


const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.dfa.DFA(ds, index) );

class FHIRPathLexer extends antlr4.Lexer {

    static grammarFileName = "FHIRPath.g4";
    static channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];
	static modeNames = [ "DEFAULT_MODE" ];
	static literalNames = [ null, "'.'", "'['", "']'", "'+'", "'-'", "'*'", 
                         "'/'", "'div'", "'mod'", "'&'", "'is'", "'as'", 
                         "'|'", "'<='", "'<'", "'>'", "'>='", "'='", "'~'", 
                         "'!='", "'!~'", "'in'", "'contains'", "'and'", 
                         "'or'", "'xor'", "'implies'", "'('", "')'", "'{'", 
                         "'}'", "'true'", "'false'", "'%'", "'$this'", "'$index'", 
                         "'$total'", "','", "'year'", "'month'", "'week'", 
                         "'day'", "'hour'", "'minute'", "'second'", "'millisecond'", 
                         "'years'", "'months'", "'weeks'", "'days'", "'hours'", 
                         "'minutes'", "'seconds'", "'milliseconds'" ];
	static symbolicNames = [ null, null, null, null, null, null, null, null, 
                          null, null, null, null, null, null, null, null, 
                          null, null, null, null, null, null, null, null, 
                          null, null, null, null, null, null, null, null, 
                          null, null, null, null, null, null, null, null, 
                          null, null, null, null, null, null, null, null, 
                          null, null, null, null, null, null, null, "DATE", 
                          "DATETIME", "TIME", "IDENTIFIER", "DELIMITEDIDENTIFIER", 
                          "STRING", "NUMBER", "LONGNUMBER", "WS", "COMMENT", 
                          "LINE_COMMENT" ];
	static ruleNames = [ "T__0", "T__1", "T__2", "T__3", "T__4", "T__5", "T__6", 
                      "T__7", "T__8", "T__9", "T__10", "T__11", "T__12", 
                      "T__13", "T__14", "T__15", "T__16", "T__17", "T__18", 
                      "T__19", "T__20", "T__21", "T__22", "T__23", "T__24", 
                      "T__25", "T__26", "T__27", "T__28", "T__29", "T__30", 
                      "T__31", "T__32", "T__33", "T__34", "T__35", "T__36", 
                      "T__37", "T__38", "T__39", "T__40", "T__41", "T__42", 
                      "T__43", "T__44", "T__45", "T__46", "T__47", "T__48", 
                      "T__49", "T__50", "T__51", "T__52", "T__53", "DATE", 
                      "DATETIME", "TIME", "DATEFORMAT", "TIMEFORMAT", "TIMEZONEOFFSETFORMAT", 
                      "IDENTIFIER", "DELIMITEDIDENTIFIER", "STRING", "NUMBER", 
                      "LONGNUMBER", "WS", "COMMENT", "LINE_COMMENT", "ESC", 
                      "UNICODE", "HEX" ];

    constructor(input) {
        super(input)
        this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    }

    get atn() {
        return atn;
    }
}

FHIRPathLexer.EOF = antlr4.Token.EOF;
FHIRPathLexer.T__0 = 1;
FHIRPathLexer.T__1 = 2;
FHIRPathLexer.T__2 = 3;
FHIRPathLexer.T__3 = 4;
FHIRPathLexer.T__4 = 5;
FHIRPathLexer.T__5 = 6;
FHIRPathLexer.T__6 = 7;
FHIRPathLexer.T__7 = 8;
FHIRPathLexer.T__8 = 9;
FHIRPathLexer.T__9 = 10;
FHIRPathLexer.T__10 = 11;
FHIRPathLexer.T__11 = 12;
FHIRPathLexer.T__12 = 13;
FHIRPathLexer.T__13 = 14;
FHIRPathLexer.T__14 = 15;
FHIRPathLexer.T__15 = 16;
FHIRPathLexer.T__16 = 17;
FHIRPathLexer.T__17 = 18;
FHIRPathLexer.T__18 = 19;
FHIRPathLexer.T__19 = 20;
FHIRPathLexer.T__20 = 21;
FHIRPathLexer.T__21 = 22;
FHIRPathLexer.T__22 = 23;
FHIRPathLexer.T__23 = 24;
FHIRPathLexer.T__24 = 25;
FHIRPathLexer.T__25 = 26;
FHIRPathLexer.T__26 = 27;
FHIRPathLexer.T__27 = 28;
FHIRPathLexer.T__28 = 29;
FHIRPathLexer.T__29 = 30;
FHIRPathLexer.T__30 = 31;
FHIRPathLexer.T__31 = 32;
FHIRPathLexer.T__32 = 33;
FHIRPathLexer.T__33 = 34;
FHIRPathLexer.T__34 = 35;
FHIRPathLexer.T__35 = 36;
FHIRPathLexer.T__36 = 37;
FHIRPathLexer.T__37 = 38;
FHIRPathLexer.T__38 = 39;
FHIRPathLexer.T__39 = 40;
FHIRPathLexer.T__40 = 41;
FHIRPathLexer.T__41 = 42;
FHIRPathLexer.T__42 = 43;
FHIRPathLexer.T__43 = 44;
FHIRPathLexer.T__44 = 45;
FHIRPathLexer.T__45 = 46;
FHIRPathLexer.T__46 = 47;
FHIRPathLexer.T__47 = 48;
FHIRPathLexer.T__48 = 49;
FHIRPathLexer.T__49 = 50;
FHIRPathLexer.T__50 = 51;
FHIRPathLexer.T__51 = 52;
FHIRPathLexer.T__52 = 53;
FHIRPathLexer.T__53 = 54;
FHIRPathLexer.DATE = 55;
FHIRPathLexer.DATETIME = 56;
FHIRPathLexer.TIME = 57;
FHIRPathLexer.IDENTIFIER = 58;
FHIRPathLexer.DELIMITEDIDENTIFIER = 59;
FHIRPathLexer.STRING = 60;
FHIRPathLexer.NUMBER = 61;
FHIRPathLexer.LONGNUMBER = 62;
FHIRPathLexer.WS = 63;
FHIRPathLexer.COMMENT = 64;
FHIRPathLexer.LINE_COMMENT = 65;




module.exports = FHIRPathLexer;
